/**
 * Formato de montos, igual en todas las pantallas.
 *
 * Se usa el separador de miles con punto decimal (formato en-US) porque así
 * venían ya los montos en los reportes y en el dashboard del cliente.
 */

export const formatNumber = (numero) =>
  new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(numero) || 0);

export const formatCurrency = (valor) => "$" + formatNumber(valor);
